const entityStyle = {
  entityContainer: {
    marginTop: 8,
    marginHorizontal: 16,
  },
};

export default entityStyle;
